/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByTitle } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    Datagrid,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { TextInput } from '../lib/wrappers/Inputs';
import { EditToolbar } from '../layout/EditToolbar';
export const PartnershipTypeLabels = { pageTitle: 'Partnership Types' };

export const PartnershipTypeList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={PartnershipTypeLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="Title" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const PartnershipTypeEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByTitle />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput source="Title" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const PartnershipTypeCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput source="Title" />
        </SimpleForm>
    </Create>
);

export const PartnershipTypeShow = (props) => (
    <Show title={<ShowTitleByTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Title" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
